module.exports = __webpack_public_path__ + "img/island-fm.11596f5c.png";